import React, { useMemo } from "react";
import { AccountInfo } from "../../api/services";
import { Typography } from "@material-ui/core";
import { formatDate } from "../../utils/formatDate";

export interface AccountStatusProps {
  account: AccountInfo;
}

export const AccountStatus: React.FC<AccountStatusProps> = ({ account }) => {
  const text = useMemo(() => {
    if (account.status === "Active") {
      return `Account active from: ${formatDate(account.startDttm)} onwards`;
    } else if (account.status === "Closed" || account.status === "Cancelled") {
      // Only cancelled accounts can end before they start
      if (account.endDttm && account.endDttm < account.startDttm) {
        return `Account cancelled on: ${formatDate(account.endDttm)}`;
      }
      return `Account was active from: ${formatDate(
        account.startDttm,
      )} to ${formatDate(account.endDttm)}`;
    } else if (
      account.status === "PendingTermination" ||
      account.status === "Terminated"
    ) {
      return `Account active from: ${formatDate(
        account.startDttm,
      )} to ${formatDate(account.endDttm)}`;
    } else {
      return `Account status unknown`;
    }
  }, [account.status, account.startDttm, account.endDttm]);

  return (
    <Typography
      variant="body2"
      color={account.status === "Cancelled" ? "textSecondary" : "textPrimary"}
    >
      {text}
    </Typography>
  );
};
